import { ReportDateInterface } from '@/components/_common/ReportSelectMonthFields';

export enum SituationOptions {
  open = 'OPEN',
  authorized = 'AUTHORIZED',
  closed = 'CLOSED',
  canceled = 'CANCELED',
}

export enum BudgetTypeOptions {
  budget = 'BUDGET',
  assurance = 'ASSURANCE',
  return = 'RETURN',
  courtesy = 'COURTESY',
  totalLoss = 'TOTAL_LOSS',
  revisions = 'REVISIONS',
}

export enum ReportType {
  totalPerBudget = 'TOTAL_PER_BUDGET',
  insurerAndPrivate = 'INSURER_AND_PRIVATE',
  estimators = 'ESTIMATORS',
  servicesAndPartsPerVehicle = 'SERVICES_AND_PART_PER_VEHICLE',
  osCost = 'OS_COST',
  partStatus = 'PART_STATUS',
  osByArea = 'OS_BY_AREAS',
}

export enum FilterByDate {
  entrance = 'ENTRANCE',
  authorization = 'AUTHORIZATON',
  shutdown = 'SHUTDOWN',
  expectedDeparture = 'EXPECTED_DEPARTURE',
  delivery = 'DELIVERY',
  exit = 'EXIT',
}

export interface WorkOrderReportFormValues extends ReportDateInterface {
  reportType?: ReportType;
  filterByDate?: FilterByDate;
  situation?: SituationOptions;
  budgetType?: BudgetTypeOptions;
  estimatorsIds?: number[];
  synthetic?: boolean;
  particular: boolean;
  parts?: boolean;
  partsProvided?: boolean;
  tasks?: boolean;
  third?: boolean;
  filterByPartAndService?: string;
}
